import { render, staticRenderFns } from "./SearchPrivacyAgree.vue?vue&type=template&id=55a41fb1"
import script from "./SearchPrivacyAgree.vue?vue&type=script&lang=js"
export * from "./SearchPrivacyAgree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/ramyashanbhag/Downloads/App/REYVEND/open-frontend-web/node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_s74suowdwcam3het7yodnr4dnu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports